module.exports = __webpack_public_path__ + "img/img-12.b992e125.png";